const Config = {
    
    whiteLabel: "Arbox",
};

export default Config;